// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `b {
  font-size: 1.5em;
}

.divider-10 {
  height: 10px;
  overflow-y: auto;
}

.divider-20 {
  height: 20px;
  overflow-y: auto;
}

.text-description {
  color: rgb(211, 211, 211);
}

.btn-custom {
  background-color: rgba(32, 32, 32, 0.8) !important;
  /* border: 1px solid green !important; */
  border-radius: 15px 0px 15px !important;
}

.btn-custom span {
 color: rgba(255, 255, 255, 0.8);
}

.btn-custom:hover {
  background-color: rgba(0, 192, 0, 0.8) !important;
  border: 1px solid rgba(0, 192, 0, 0.8) !important;
}

.btn-custom:hover span {
 color: rgba(16, 16, 16, 0.8);
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/signin.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;CACC,4BAA4B;AAC7B","sourcesContent":["b {\n  font-size: 1.5em;\n}\n\n.divider-10 {\n  height: 10px;\n  overflow-y: auto;\n}\n\n.divider-20 {\n  height: 20px;\n  overflow-y: auto;\n}\n\n.text-description {\n  color: rgb(211, 211, 211);\n}\n\n.btn-custom {\n  background-color: rgba(32, 32, 32, 0.8) !important;\n  /* border: 1px solid green !important; */\n  border-radius: 15px 0px 15px !important;\n}\n\n.btn-custom span {\n color: rgba(255, 255, 255, 0.8);\n}\n\n.btn-custom:hover {\n  background-color: rgba(0, 192, 0, 0.8) !important;\n  border: 1px solid rgba(0, 192, 0, 0.8) !important;\n}\n\n.btn-custom:hover span {\n color: rgba(16, 16, 16, 0.8);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
